import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconThumbsDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconThumbsDown"><Path fillRule="evenodd" clipRule="evenodd" d="M13.6472 22H12.4147C10.5741 22 9.17547 20.3533 9.45744 18.5384L9.85181 16H5.98994C3.56858 16 1.71124 13.8576 2.03703 11.46L2.71645 6.46001C2.98543 4.48052 4.67151 3 6.66936 3L22 3L22 14H17.6331L13.6472 22ZM18 12H20L20 5H18L18 12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconThumbsDown;
